import backofficeService from '../../api/backoffice'

export default {

  getById(id) {
    return backofficeService.Api().get(`api/invoice/bystoreId/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get All invoice
   * @param {*} params Query Options
   */
  getAllInvoice(id, params) {
    return backofficeService.Api().get(`api/invoice/getInviocesByStoreId/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getInvoiceById(id, params) {
    console.log('req.params.invoiceID', id)
    return backofficeService.Api().get(`api/invoice/${id.id}`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getStripeCard(id) {
    return backofficeService.Api().get(`api/stripe/cards/${id}`)
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  emailInvoice(id, data) {
    return backofficeService.Api().post(`api/invoice/email/${id}`, data)
      .then(response => response)
      .catch(error => error)
  },
  createInvoice(data) {
    return backofficeService.Api().post('api/invoice', data)
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  collectInvoice(id, data) {
    console.log('test colloction ', id)
    return backofficeService.Api().post(`api/invoice/charge/${id}`, data)
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  /**
   * create credit card
   * @param {*} params Query Options
   */
  addCreditCard(data) {
    let url = null
    if (data.stripeID) {
      url = 'api/stripe'
    } else {
      url = 'api/stripe/createCustomer'
    }
    return backofficeService.Api().post(url, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
